document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
      this._bindQuickFilterEvents();
    },
    _bindQuickFilterEvents() {
      if (this._quickFiltersBound) return;
      this._quickFiltersBound = true;

      this.$el.addEventListener('click', (event) => {
        const chip = event.target.closest('.impex-qf__chip');
        if (!chip || chip.disabled || !this.$el.contains(chip)) return;
        event.preventDefault();
        this.toggleQuickFilterChip(chip, chip.getAttribute('data-qf-index'));
      });

      this.$el.addEventListener('change', (event) => {
        const input = event.target;
        if (!input || input.type !== 'checkbox') return;
        if (!input.closest('.impex-qf')) return;
        this.onQuickFilterChange(input);
      });
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', () => {
        this._initLayout();
      });
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const form = document.getElementById('FacetFiltersForm');
        if (!form) return;
        const searchParams = this._createSearchParams(form);
        this._renderPage(searchParams);
        const sortSelect = document.getElementById('FormSelectFilter');
        if (this.isDesktop && sortSelect) sortSelect.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    _syncFilterCheckbox(name, value, checked) {
      document.querySelectorAll('input[type="checkbox"]').forEach((node) => {
        if (node.name === name && node.value === value) {
          node.checked = checked;
        }
      });
    },
    _syncQuickFilterChip(root, name, value, checked) {
      if (!root) return;
      root.querySelectorAll('.impex-qf__menu--desktop input[type="checkbox"]').forEach((input, index) => {
        if (input.name !== name || input.value !== value) return;
        const chip = root.querySelector('.impex-qf__chip[data-qf-index="' + index + '"]');
        if (chip) chip.classList.toggle('is-active', checked);
      });
    },
    toggleQuickFilterChip(el, index) {
      const root = el.closest('.impex-qf');
      if (!root) return;
      const input = root.querySelector('.impex-qf__menu--desktop input[data-qf-index="' + index + '"]');
      if (!input || input.disabled) return;
      const nextChecked = !input.checked;
      this._syncFilterCheckbox(input.name, input.value, nextChecked);
      el.classList.toggle('is-active', nextChecked);
      this.onSubmit(0);
    },
    onQuickFilterChange(el) {
      this._syncFilterCheckbox(el.name, el.value, el.checked);
      this._syncQuickFilterChip(el.closest('.impex-qf'), el.name, el.value, el.checked);
      this.onSubmit(0);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);;
          
          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _parseSectionHtml(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    },
    _findInSection(doc, id) {
      let el = doc.getElementById(id);
      if (el) return el;
      doc.querySelectorAll('template').forEach((template) => {
        if (el) return;
        el = template.content.getElementById(id);
      });
      return el;
    },
    _createSearchParams(form) {
      const params = new URLSearchParams();
      const seen = new Set();

      const appendUnique = (key, value) => {
        if (key == null || key === '') return;
        // Skip empty price/range fields so they don't pollute the URL
        if (value === '' || value == null) return;
        const token = key + '\0' + value;
        if (seen.has(token)) return;
        seen.add(token);
        params.append(key, value);
      };

      for (const [key, value] of new FormData(form).entries()) {
        appendUnique(key, value);
      }

      // Quick-filter checkboxes are outside the form — merge checked values without duplicates
      document.querySelectorAll('.impex-qf input[type="checkbox"]:not(:disabled)').forEach((input) => {
        if (!input.checked || !input.name) return;
        appendUnique(input.name, input.value);
      });

      return params.toString();
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this.loading = true;

      // Always update URL before cache/fetch so re-applying a cached filter still syncs the address bar
      if (updateURLHash) this._updateURLHash(searchParams);

      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams]);
        return;
      }

      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          this.cachedResults[searchParams] = responseText;
          this._renderResults(responseText);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      this._renderQuickFilters(html);
      this._initLayout();
      this.loading = false;
    },
    _renderQuickFilters(html) {
      const doc = this._parseSectionHtml(html);
      const source = doc.querySelector('.impex-quick-filters');
      const dest = document.querySelector('.impex-quick-filters');
      if (source && dest) {
        dest.innerHTML = source.innerHTML;
      }
    },
    _renderFilters(html) {
      const parsedHTML = this._parseSectionHtml(html);
      const selectBlockFiltesDrawer = document.querySelector('.form-drawer');
      const selectBlockFiltesAside = document.querySelector('.form-aside');
      const activeTag = document.getElementById('active-filter-tag');
      const activeTagSource = this._findInSection(parsedHTML, 'active-filter-tag');

      if (activeTag && activeTagSource) {
        activeTag.innerHTML = activeTagSource.innerHTML;
        this._initAlpineTree(activeTag);
      }

      // Only swap drawer filter body — keep #ProductFilter shell so overlay/close Alpine stays intact
      if (selectBlockFiltesDrawer) {
        const drawerSource = parsedHTML.querySelector('.form-drawer');
        const destBody = selectBlockFiltesDrawer.querySelector('[data-facets-drawer-body]');
        const srcBody = drawerSource && drawerSource.querySelector('[data-facets-drawer-body]');

        if (destBody && srcBody) {
          destBody.innerHTML = srcBody.innerHTML;
          this._initAlpineTree(destBody);
        } else if (drawerSource) {
          selectBlockFiltesDrawer.innerHTML = drawerSource.innerHTML;
          this._initAlpineTree(selectBlockFiltesDrawer);
        }

        const countDrawer = document.getElementById('ProductCountDrawer');
        const countDrawerSource = this._findInSection(parsedHTML, 'ProductCountDrawer');
        if (countDrawer && countDrawerSource) {
          countDrawer.innerHTML = countDrawerSource.innerHTML;
          this._copyCountMeta(countDrawerSource, countDrawer);
        }

        this._renderAdditionalElements(parsedHTML);
      }

      if (selectBlockFiltesAside) {
        const asideSource = parsedHTML.querySelector('.form-aside');
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        if (asideSource) {
          selectBlockFiltesAside.innerHTML = asideSource.innerHTML;
          this._renderAdditionalElements(parsedHTML);
          this._initAlpineTree(selectBlockFiltesAside);
        }
      }
      this._renderAdvancedFilters(parsedHTML);
    },
    _initAlpineTree(el) {
      if (el && window.Alpine && typeof Alpine.initTree === 'function') {
        Alpine.initTree(el);
      }
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll('.filter-advanced');
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        });
      }
    },
    _renderProductGridContainer(html) {
      const doc = this._parseSectionHtml(html);
      const source = doc.getElementById('ProductGridContainer');
      const dest = document.getElementById('ProductGridContainer');
      if (source && dest) dest.innerHTML = source.innerHTML;
    },
    _copyCountMeta(source, dest) {
      if (!source || !dest) return;
      ['data-product-count', 'data-count-from', 'data-count-total', 'data-count-template'].forEach((attr) => {
        if (source.hasAttribute(attr)) dest.setAttribute(attr, source.getAttribute(attr));
      });
    },
    _renderProductCount(html) {
      const doc = this._parseSectionHtml(html);
      // Impex count lives in #FacetsWrapperDesktop inside x-teleport <template> — not found by getElementById on the doc root
      const headerSource = this._findInSection(doc, 'ProductCount_header');
      const productCountEl = doc.getElementById('ProductCount');
      const container = document.getElementById('ProductCount_header');
      const containerDrawer = document.getElementById('ProductCountDrawer');
      const countHtml = headerSource
        ? headerSource.innerHTML
        : (productCountEl ? productCountEl.innerHTML : null);
      const metaSource = headerSource || productCountEl;

      if (countHtml != null && container) {
        container.innerHTML = countHtml;
        container.classList.remove('loading');
        this._copyCountMeta(metaSource, container);
      }
      if (productCountEl && containerDrawer) {
        containerDrawer.innerHTML = productCountEl.innerHTML;
        this._copyCountMeta(metaSource, containerDrawer);
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      const source = html.getElementById('ProductPerPage');
      if (container && source) container.innerHTML = source.innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});